// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"8c7a67ea","837":"31d6cfe0","997":"774c9658"}[chunkId] + ".chunk.css";
};